import React, { useContext } from 'react'

import { FileState } from 'ui/components/FileUpload/types'

export type FileUploadItemContextValue = {
    id: string
    fileState: FileState | undefined
    nameId: string
    sizeId: string
    statusId: string
}

export const FileUploadItemContext = React.createContext<FileUploadItemContextValue | null>(null)

export function useFileUploadItemContext(): FileUploadItemContextValue {
    const context = useContext(FileUploadItemContext)

    if (!context) {
        throw new Error(
            'useFileUploadItemContext must be used within a FileUploadItemContextProvider'
        )
    }

    return context
}
